import { render, staticRenderFns } from "./CampaignStats.vue?vue&type=template&id=d3b8d22c&scoped=true&"
import script from "./CampaignStats.vue?vue&type=script&lang=js&"
export * from "./CampaignStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b8d22c",
  null
  
)

export default component.exports